export enum RoutePath {
  Dashboard = "/",
  HedgeBeaconAnalysis = "/analyst/recommendation",
  HedgeBeaconAlert = "/analyst/alert",
  HedgeBeaconMarketThoughts = "/analyst/market_thoughts",
  HedgeBeaconDailyUpdates = "/analyst/daily_updates",
  HedgeBeaconEmailPreview = "/analyst/email/preview",
  TicketsWeightDashboard = "/weight/tickets/dashboard",
  TicketsTradingDashboard = "/trading/tickets/dashboard",
  TicketsUpload = "/tickets/upload",
  SalesAndPurchaseReports = "/tickets/freight",
  DormanStagedDashboard = "/tickets/dorman/staged",
  MarketingTransactionalReport = "/reports/marketing",
  MarketingFees = "/reports/marketing/fees",
  MarketingFeeAccrual = "/reports/marketing/accrual",
  SpreadReport = "/reports/spread",
  ARReport = "/reports/ar",
  TicketsJobsDashboard = "/tickets/jobs",
  TradingBacktest = "/trading/backtest",
  TradingAtsData = "/trading/ats/dashboard",
  TradingAtsLive = "/trading/ats/live",
  QueuedDocuments = "/document/queue",
  DocumentsQueue = "/documents/queue",
  DocumentsQueueOtc = "/documents/queue/otc",
  DocumentsQueueNightly = "/documents/queue/nightly",
  DeveloperDashboard = "/developer/dashboard",
  System = "/system",
  SystemQueues = "/system/queues",
  DeveloperJobsDashboard = "/developer/jobs/dashboard",
  DeveloperTestPage = "/developer/test",
  DeveloperClientNotifications = "/developer/client/notifications",
  MobileClientUsers = "/mobile/client/users",
  MobileResources = "/mobile/client/resources",
  Authenticate = "/authenticate",
  Login = "/login",
  ManageCustomers = "/ManageCustomers",
  LocationDashboard = "/location",
  CostBasisDashboard = "/costs_basis",
  CallLogsDashboard = "/call_logs",
  VideoDashboard = "/video/splicing",
  HedgeBeaconSplicing = "/video/hedgebeacon/splicing",
  ContactsDashboard = "/contacts",
  MarketZoneDashboard = "/marketZone",
  ContractsDashboard = "/contracts",
  ContractsGeneralDashboard = "/contracts/general",
  ContractsOtcDashboard = "/contracts/otc",
  ContractsLanguageGeneralDashboard = "/contracts/language/general",
  ContractsLanguageOtcDashboard = "/contracts/language/otc",
  ContractsLanguageDashboard = "/contracts/language",
  GeneralContractsDashboard = "/general/contracts",
  GeneralContractSettingsDashboard = "/general/contracts/settings",
  StagedGeneralContractsDashboard = "/general/contracts/staged",
  AgtechContractsDashboard = "/agtech/contracts",
  ContractQuantityAlertDashboard = "/contract/quantity/alert",
  ManageTraders = "/ManageTraders",
  CogsReports = "/cogs",
  OtcDashboard = "/otc",
  PositionsDashboard = "/trading/positions",
  DestinationMessagingDashboard = "/destination/messaging",
  DestinationHoursDashboard = "/destination/hours",
  DestinationHoursImprovedDashboard = "/destination-hours",
  DestinationMessagingConsentScreenshot = "/destination-consent-screenshot",
  DestinationMessagingConsent = "/destination-consent",
  NewsArticles = "/news/articles",
  ManagePermissions = "/permissions/manage",
  MobilePermissions = "/permissions/mobile",
  MobilePermissionsClient = "/permissions/mobile/client",
  MobilePermissionsNonClient = "/permissions/mobile/non-client",
  MobilePermissionsFreight = "/permissions/mobile/freight",
  MobilePermissionsUserDetail = "/permissions/mobile/:userId",
  InvoiceAndStatementReport = "/reports/invoices",
  PrivacyPolicy = "/privacy-policy",
  DeferredPayments = "/payments/deferred",
  Chat = "/chats",
  GoToChat = "/chats/goto",
  TaskChecklists = "/task/checklists",
  KnowledgeTasks = "/tasks",
  KnowledgeTaskDetail = "/tasks/:taskId",
  KnowledgeTaskCreate = "/tasks/create",
  KnowledgeTaskEdit = "/tasks/:taskId/edit",
  ManualPriceData = "/price-data/manual",
  DirectSales = "/direct-sales",
  Settings = "/settings",
  GrainSamplesDashboard = "/grain/samples",
  GrainPositionsDashboard = "/grain/positions",
  RiskManagement = "/risk/management",
  RiskManagementCashSales = "/risk/management/cashSales",
  RiskManagementCropProfiles = "/risk/management/profiles",
  RiskManagementSummary = "/risk/management/summary",
  RiskManagementFull = "/risk/full",
  RiskManagementFullBrokerage = "/risk/full/brokerage",
  RiskManagementFullBrokerageOpenOrders = "/risk/full/brokerage/open-orders",
  RiskManagementFullBrokeragePAndS = "/risk/full/brokerage/p-and-s",
  TTOrders = "/risk/full/brokerage/tt-orders",
  TTOrdersDashboard = "/risk/full/brokerage/tt-orders/dashboard",
  TtOrdersV2Dashboard = "/risk/full/brokerage/v2/tt-orders",
  TtActiveOrdersDashboard = "/risk/full/brokerage/v2/active-orders",
  TTOrdersDetail = "/risk/full/brokerage/tt-orders/dashboard/order/:guid_order_id",
  RiskManagementSalesNotes = "/risk/activities/sales-notes",
  RiskManagementRecommendations = "/risk/recommendations",
  RiskMarketZone = "/risk/market-zone",
  RiskMerchValues = "/risk/merch-values",
  RiskMerchValuesActive = "/risk/merch-values/active",
  RiskMerchValuesHistory = "/risk/merch-values/history",
  BirthdayFund = "/fund/birthday",
  BirthdayFundRequests = "/fund/birthday/requests",
  BirthdayFundCertificates = "/fund/birthday/certificates",
  BirthdayFundCertificateList = "/fund/birthday/certificates/list",
  BirthdayFundCreateCertificate = "/fund/birthday/certificates/create",
  BirthdayFundCreateInstance = "/fund/birthday/certificates/instance/create",
  BeaconFund = "/fund/beacon",
  GFReport = "/reports/gf",
  OtcPrem = "/reports/otcPrem",
  ContractMTM = "/reports/contracts/mtm",
  McCluskyFeeAccrual = "/reports/mccluskyFeeAccrual",
  Brokerage = "/brokerage",
  BrokerageFiles = "/brokerage/files",
  BrokerageReportSettings = "/brokerage/report-settings",
  ExportSalesTracker = "/reports/export_sales_tracker",
  CfrDocuments = "/contracts/cfr",
  CfrDocumentsReports = "/contracts/cfr/reports",
  CfrDocumentsTemplates = "/contracts/cfr/templates",
  CfrDocumentsTemplatesCreate = "/contracts/cfr/templates/create",
  CfrDocumentsTemplatesView = "/contracts/cfr/templates/:templateId/view",
  CfrDocumentsInstances = "/contracts/cfr/instances",
  CfrDocumentsInstanceSentPreview = "/contracts/cfr/templates/:templateId/instances/:instanceId/sent",
  CfrDocumentsInstanceFinalPreview = "/contracts/cfr/templates/:templateId/instances/:instanceId/final",
  CfrBulkSendBatch = "/contracts/cfr/bulk-send-batches/:batchId",
  Agtech = "/agtech/",
  AgtechReports = "/agtech/reports",
  AgtechTickets = "/agtech/tickets",
  AgtechSettlements = "/agtech/settlements",
  AgtechAdvances = "/agtech/advances",
  AchDocuments = "/contracts/ach",
  AchDocumentsTemplates = "/contracts/ach/templates",
  AchDocumentsTemplatesCreate = "/contracts/ach/templates/create",
  AchDocumentsTemplatesView = "/contracts/ach/template/:template_id",
  AchDocumentsInstanceSentPreview = "/contracts/ach/templates/:templateId/instances/:instanceId/sent",
  AchDocumentsInstanceFinalPreview = "/contracts/ach/templates/:templateId/instances/:instanceId/final",
  MarketSimilarity = "/market_similarity",
  AchDocumentsReviewInstances = "/contracts/ach/review-instances",
  DestinationPackets = "/contracts/destination_packets",
  DestinationPacketsTemplates = "/contracts/destination_packets/templates",
  DestinationPacketsTemplatesCreate = "/contracts/destination_packets/templates/create",
  DestinationPacketsTemplatesView = "/contracts/destination_packets/template/:template_id",
  DestinationPacketsTemplatesPreview = "/contracts/destination_packets/template/:template_id/preview",
  DestinationPacketsSendEnvelope = "/contracts/destination_packets/send-envelope",
  DestinationPacketsInstances = "/contracts/destination_packets/instances",
  DestinationPacketsInstanceSentPreview = "/contracts/destination_packets/template/:template_id/instances/:instance_id/sent",
  DestinationPacketsInstanceFinalPreview = "/contracts/destination_packets/template/:template_id/instances/:instance_id/final",
  FreightDashboard = "/freight",
  FreightImagesDashboard = "/freight/images",
  ExperimentsDataTableBasic = "/experiments/data-table-basic",
  ExperimentsDataTableColoredRows = "/experiments/data-table-colored-rows",
  TestOtcFormV2 = "/test/otc-form-v2",
  RiskExperiments = "/risk/experiments",
  RiskExperimentsSummary = "/risk/experiments/summary",
  Assistant = "/assistant",
  AssistantV1 = "/assistant/v1",
  AssistantV2 = "/assistant/v2",
  PaymentRemittancePdfs = "/payment-remittance/pdfs",
  PaymentRemittancePdfsNew = "/payment-remittance/pdfs/new",
  ProducerRiskOcNcReport = "/reports/producer-risk-oc-nc",
}

export interface RouteRuntimeRules {
  localhostOnly?: boolean;
}

export const ROUTE_RUNTIME_RULES: Partial<Record<RoutePath, RouteRuntimeRules>> = {
  [RoutePath.ExperimentsDataTableBasic]: { localhostOnly: true },
  [RoutePath.ExperimentsDataTableColoredRows]: { localhostOnly: true },
  [RoutePath.TestOtcFormV2]: { localhostOnly: true },
};
